import React, { useMemo, useState, useEffect, useRef } from "react";
import styled from "styled-components";
import { Form, Formik } from "formik";
import editIcon from "../../Images/edit.svg";
import deleteIcon from "../../Images/Delete.svg";
import { Language } from "../../utilities/constants";
import { read } from "../../DataApi/read";
import { write } from "../../DataApi/write";
import { useSession } from "../../authentications/SessionContext";
import { useLanguage } from "../../Components/LangTranslation/LanguageContext";
import LoaderWrapper from "../../Components//Loader/LoaderWrapper";
import cameraIcon from "../../Images/camera.svg";
import { newUserFormValidationSchema } from "../../utilities/Validation Schema/NewUserFormValidationSchema";
import UploadedImage from "../../Components/UploadedImagedComponent/UploadedImage";
import { fileToBase64 } from "../../utilities/fileToBase64";
import { useSnackbar } from "notistack";
import { FormContainer } from "../../Components/StyledComponents/FormConatiner/FormContainerStyle";
import { Button } from "../../Components/StyledComponents/Buttons/ButtonStyle";
import { handleResponse } from "../../utilities/handleResponse";
import useFormikSubmitButton from "../../CustomHooks/useFormikSubmitButton";
import { primaryColor } from "../../utilities/colors";
import SVGButton from "../../Components/Buttons/SVGButton";
import useConfirmationModal from "../../Components/ConfirmationModal/useConfirmationModal";
import FormikInput from "../../Components/Formik/FormikInput";
import PaletteEditor from "../../Components/SetupMiniStoreComponents/PaletteEditor";
import Palette from "../../Components/SetupMiniStoreComponents/Palette";

const SetupMiniStore = ({ handleCloseModal, selectedUser }) => {
  const { sessionInfo } = useSession();
  const { company_id, context, current_website_id } = sessionInfo;
  const { language, translations } = useLanguage();
  const t = translations[language];
  const { setMetaData, setTitle } = useConfirmationModal();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [palette, setPalette] = useState([]);
  const { setIsSubmitting, FormikSubmitButtons } = useFormikSubmitButton();
  const [previousInputs, setPreviousInputs] = useState({});
  const [view, setView] = useState("view");
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const logoRef = useRef();
  const heroRef = useRef();

  const [formData, setFormData] = useState({
    logo: "",
    logo_url: "",
    hero_img: "",
    hero_img_url: "",
    website_palette: "",
    x_url: "",
    insta_url: "",
    fb_url: "",
  });
  const fetchWebsiteDetail = async () => {
    setIsLoading(true);
    let response = await read({
      id: current_website_id,
      context,
      company_id,
      model: "website",
    });
    response = JSON.parse(response)?.result?.[0];
    // console.log("response", response);
    let inputList = {
      ...response,
      logo: response?.logo,
      logo_url: response?.logo_url,
      hero_img: response?.hero_img,
      hero_img_url: response?.hero_img_url,
      website_palette: response?.website_palette,
      x_url: response?.x_url,
      insta_url: response?.insta_url,
      fb_url: response?.fb_url,
    };
    setFormData({ ...inputList });
    setPreviousInputs({ ...inputList });
    inputList = {};
    setIsLoading(false);
  };

  const getPayload = (payload) => ({
    logo: payload?.logo || "",
    logo_url: payload?.logo_url || false,
    hero_img: payload?.hero_img || false,
    hero_img_url: payload?.hero_img_url || "",
    website_palette: payload?.website_palette || "",
    x_url: payload?.x_url || "",
    insta_url: payload?.insta_url || "",
    fb_url: payload?.fb_url || "",
  });

  const handleEditWebsiteForm = async (values) => {
    const newChanges = {};
    const oldPayload = getPayload(previousInputs);
    const newPayload = getPayload(values);

    Object.keys(newPayload).forEach((key) => {
      if (JSON.stringify(newPayload[key]) != JSON.stringify(oldPayload[key])) {
        newChanges[key] = newPayload[key];
      }
    });

    if (Object.keys(newChanges).length === 0) {
      setView("view");
      return;
    }
    let response = await write({
      id: current_website_id,
      change: { ...newChanges },
      company_id,
      context,
      model: "website",
    });
    response = JSON.parse(response);
    if (response.result) {
      setView("view");
    }
    return response;
  };

  const handleSubmitForm = async (...args) => {
    setIsSubmitting(true);
    let response = {};
    let successMessage = "";
    if (view === "edit") {
      successMessage = "Storefront Edited Successfully";
      response = await handleEditWebsiteForm(...args);
    }
    setIsSubmitting(false);
    // toggleModal();
    handleResponse({
      response,
      setMetaData,
      setTitle,
      successMessage,
    });
    setIsLoadingSubmit(false);
  };

  const handleChangeimage1920 = (e, setFieldValue, field) => {
    const file = e.target.files[0];
    if (file) {
      fileToBase64(file, (_, base64) => setFieldValue(field, base64));
    }
  };

  useEffect(() => {
    fetchWebsiteDetail();
  }, []);

  const disableInputs = useMemo(() => view === "view", [view]);
  return (
    <LoaderWrapper isLoading={isLoading} height="50vh" width="800px">
      <Formik
        enableReinitialize
        initialValues={formData}
        onSubmit={handleSubmitForm}
      >
        {({ values, setFieldValue }) => (
          <Form className="my-3">
            {/* {console.log("values", values)} */}
            <div className="container col-12 d-flex flex-column justify-content-center align-items-center">
              {view === "view" && (
                <div
                  className="col-12 d-flex justify-content-start p-2 my-4"
                  style={{
                    border: "1px solid #cbcbcb",
                    borderRadius: "15px",
                    borderStyle: "dashed",
                  }}
                >
                  <SVGButton
                    hoverColor={"#ff5837"}
                    icon={editIcon}
                    onClick={() => {
                      setView("edit");
                    }}
                    className="me-2"
                  />
                </div>
              )}
              {!disableInputs && (
                <FormikSubmitButtons setupMiniStore={true} setView={setView} />
              )}
              <div
                className="col-12 d-flex flex-column justify-content-center align-items-center p-4"
                style={{
                  border: "1px solid #cbcbcb",
                  borderRadius: "15px",
                  borderStyle: "dashed",
                }}
              >
                <h4 style={{ fontFamily: "Comfortaa" }}>Logo Image:</h4>
                <div
                  className="my-3"
                  onClick={() => {
                    if (!disableInputs) logoRef.current.click();
                  }}
                >
                  <UploadedImage
                    height="200px"
                    width="auto"
                    src={values.logo || cameraIcon}
                  />
                  <input
                    ref={logoRef}
                    type="file"
                    name="logo"
                    hidden
                    onChange={(e) =>
                      handleChangeimage1920(e, setFieldValue, "logo")
                    }
                  />
                </div>
              </div>
              <div
                className="col-12 d-flex flex-column justify-content-center align-items-center p-4"
                style={{
                  border: "1px solid #cbcbcb",
                  borderRadius: "15px",
                  borderStyle: "dashed",
                }}
              >
                <h4 style={{ fontFamily: "Comfortaa" }}>Hero Image:</h4>
                <div
                  className="my-3"
                  onClick={() => {
                    if (!disableInputs) heroRef.current.click();
                  }}
                >
                  <UploadedImage
                    height="200px"
                    width="auto"
                    src={values.hero_img || cameraIcon}
                  />
                  <input
                    ref={heroRef}
                    type="file"
                    name="hero_img"
                    hidden
                    onChange={(e) =>
                      handleChangeimage1920(e, setFieldValue, "hero_img")
                    }
                  />
                </div>
              </div>
              <div
                className="col-12 d-flex flex-column justify-content-center align-items-center p-4"
                style={{
                  border: "1px solid #cbcbcb",
                  borderRadius: "15px",
                  borderStyle: "dashed",
                }}
              >
                <h4 style={{ fontFamily: "Comfortaa" }}>Palette:</h4>
                <Palette
                  paletteString={values.website_palette}
                  setFieldValue={setFieldValue}
                  disableInputs={disableInputs}
                  setPalette={setPalette}
                />
                <PaletteEditor
                  isModalOpen={isModalOpen}
                  setIsModalOpen={setIsModalOpen}
                  palette={palette}
                  setPalette={setPalette}
                  disabled={disableInputs}
                />
              </div>
              <div
                className="col-12 d-flex flex-column justify-content-center align-items-center p-4"
                style={{
                  border: "1px solid #cbcbcb",
                  borderRadius: "15px",
                  borderStyle: "dashed",
                }}
              >
                <h4 style={{ fontFamily: "Comfortaa" }}>Social Media Urls:</h4>
                <div className="my-3 col-6">
                  <FormikInput
                    disabled={disableInputs}
                    name="insta_url"
                    placeholder={t["Your Instagram Link"]}
                  />
                </div>
                <div className="my-3 col-6">
                  <FormikInput
                    disabled={disableInputs}
                    name="x_url"
                    placeholder={t["Your X Link"]}
                  />
                </div>
                <div className="my-3 col-6">
                  <FormikInput
                    disabled={disableInputs}
                    name="fb_url"
                    placeholder={t["Your Facebook Link"]}
                  />
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </LoaderWrapper>
  );
};

export default SetupMiniStore;
